import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Table,
  Col,
  Message,
  Form,
  Modal,
  Spin,
  Tag,
  Button,
  Popconfirm,
  Dropdown,
  Divider,
  Menu,
  Input,
  InputNumber,
  Checkbox,
  Select,
  message,
  Space,
} from "antd";

import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";
import ToExcel from "./toExcel";
import axios from "../../axiosConfig";
export default function Coupons() {
  const [vendorTable, setVendorsTable] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [spin, setSpin] = useState(true);
  const [vendors, setVendors] = useState([]);
  const [coupons, setCoupons] = useState([]);
  const sourceData = useRef();
  

  const [showCoupons, setShowCoupons] = useState(false);

  const [form] = Form.useForm();
  const [couponForm] = Form.useForm();
  const [vendorModal, showVendorModal] = useState(false);
  const [addCoupons, showCouponsModal] = useState(false);

  const currVendor = useRef();
  const currCouponsTable = useRef()
  const [tableData, setTableData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [couponComments, setCouponComments] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [forceDelete, setForceDelete] = useState(false);
  const deleteVendorRef = useRef(null);
  const [editForm] = Form.useForm();
  const [editCouponModal, setEditCouponModal] = useState(false);
  const editCouponRef = useRef(null);
  const [selectedCoupons, setSelectedCoupons] = useState([]);
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [multiVendorView, setMultiVendorView] = useState(false);
  const [behaviors, setBehaviors] = useState([]);
  const [editVendorForm] = Form.useForm();
  const [editVendorModal, setEditVendorModal] = useState(false);
  const editVendorRef = useRef(null);
  const [resetUsersModal, setResetUsersModal] = useState(false);
  const [vendorSearch, setVendorSearch] = useState("");
  const vendorSearchRef = useRef("");
  const [fullFlowForm] = Form.useForm();
  const [fullFlowModal, setFullFlowModal] = useState(false);
  const [leaderboardList, setLeaderboardList] = useState([]);
  const [lbExtraFields, setLbExtraFields] = useState([]);
  const [flowStatus, setFlowStatus] = useState({ running: false, steps: [] });
  useEffect(() => {
    axios.get("/dashboard/limit/leaderboard-names/").then((res) => {
      setLeaderboardList(res.data.leaderboards || []);
    }).catch(() => {
      setLeaderboardList([]);
    });
    axios.get("/vendors/all/").then((res) => {
      const { vendors: vendors_list, behaviors: behaviors_list } = res.data;
      setBehaviors(behaviors_list || []);
      setSpin(false);
      let arr = [];
      if (vendors_list && vendors_list.length > 0) {
        vendors_list.map((o) => {
          arr.push({
            key: o.id,
            id: o.id,
            vendor_name: o.vendor_name,
            behavior: o.behavior,
            creation_date: o.creation_date,
            coupons_ref: o.coupons_ref,
          });
        });
        sourceData.current = arr;
        if (vendorSearchRef.current) {
          const lower = vendorSearchRef.current.toLowerCase();
          setVendors(arr.filter((v) => v.vendor_name.toLowerCase().includes(lower)));
        } else {
          setVendors(arr);
        }
      }
      if (currVendor?.current?.coupons_ref > 0) {
        setCouponsTable();
      }
    });
  }, [refreshKey]);
  const detailColumns = [
    {
      title: 'Email',
      dataIndex: 'email',
    },
    {
      title: 'Activation Date',
      dataIndex: 'activation_date',
    },
    {
      title: 'Expiration Date',
      dataIndex: 'expiration_date',
    },
    {
      title: 'Status',
      dataIndex: 'status',
    },
    {
      title: 'Days Left',
      dataIndex: 'days_left',
    },
  ];
  const columns = [
    {
      key: "id",
      title: "id",
      dataIndex: "id",
    },
    {
      key: "vendor_name",
      title: "Name",
      dataIndex: "vendor_name",
    },
    {
      key: "behavior",
      title: "Behavior",
      dataIndex: "behavior",
    },
    {
      key: "creation_date",
      title: "Creation Date",
      dataIndex: "creation_date",
      sorter: (a, b) => {
        const da = a.creation_date ? new Date(a.creation_date) : new Date(0);
        const db = b.creation_date ? new Date(b.creation_date) : new Date(0);
        return da - db;
      },
      defaultSortOrder: "descend",
      render: (val) => val ? new Date(val).toLocaleDateString() : "—",
    },
    {
      key: "coupons_ref",
      title: "Coupons ref",
      dataIndex: "coupons_ref",
    },
    {
      title: "Actions",
      key: "inspection",
      render: (text, record) => (
        <Space size="large">
          <a onClick={() => ViewVendorCoupons(record)}>View</a>
          <a onClick={() => EditVendorOpen(record)}>Edit</a>
          <a onClick={() => DeleteVendor(record)}>Delete</a>
          <a onClick={() => AddCoupons(record)}>Add coupons</a>
        </Space>
      ),
    },
  ];

  const coupon_colums = [
    {
      key: "coupon_id",
      title: "coupon id",
      dataIndex: "coupon_id",
      width: 300,
    },
    {
      key: "creation_date",
      title: "creation date",
      dataIndex: "creation_date",
      width: 300,
    },
    {
      key: "activation_date",
      title: "activation date",
      dataIndex: "activation_date",
    },
    {
      key: "expiration_date",
      title: "expiration date",
      dataIndex: "expiration_date",
      width: 300,
    },
    {
      key: "duration",
      title: "days duration",
      dataIndex: "duration",
      width: 200,
    },
    {
      key: "state",
      title: "state",
      dataIndex: "state",
    },
    {
      key: "usage_limit",
      title: "Redeem limit",
      dataIndex: "usage_limit",
      width: 100,
    },
    {
      key: "usage_count",
      title: "Usage Count",
      dataIndex: "usage_count",
      width: 100,
    },
    {
      key: "comment",
      title: "comment",
      dataIndex: "comment",
      width: 300,
      render: (text, record) => (
        <div>
          <Input 
            placeholder="Enter comment" 
            value={couponComments[record.coupon_id] || text} 
            onChange={(e) => handleCommentChange(e.target.value, record.coupon_id)}
          />
          <Button 
            style={{marginTop: '10px'}} 
            onClick={() => handleSaveComment(record.coupon_id)}
          >
            Save
          </Button>
        </div>
      ),
    },
    {
      key: "action",
      title: "Action",
      render: (text, record) => (
        <Space>
          <button onClick={() => handleCouponClick(record.coupon_id)}>View Details</button>
          <button onClick={() => EditCoupon(record)}>Edit</button>
        </Space>
      ),
    },
  ];
  function handleCommentChange(value, coupon_id) {
    // Set the value for this specific coupon_id
    setCouponComments(prev => ({
      ...prev,
      [coupon_id]: value
    }));
  }
  function handleSaveComment(coupon_id) {
    const comment = couponComments[coupon_id];
    if (comment) {
      axios.post("/coupons/add-comment/", {
        coupon_id: coupon_id,
        comment: comment
      })
      .then((res) => {
        // Do something after successful save. Maybe clear the comment?
        // setCouponComments(prev => {
        //   const newComments = {...prev};
        //   delete newComments[coupon_id];
        //   return newComments;
        // });
      })
      .catch(error => {
        console.error("Error saving the comment:", error);
        // Maybe notify the user of the error?
      });
    } else {
      // Maybe notify the user that comment is empty?
    }
  }
  function ViewVendorCoupons(record) {
    if (record.coupons_ref === 0) {
      message.info("Vendor has no coupons");
    } else {
      currVendor.current = record;
      setMultiVendorView(false);
      setSelectedCoupons([]);
      setShowCoupons(true);
      setCouponsTable();
    }
  }

  function ViewSelectedVendorsCoupons() {
    setSpin(true);
    currVendor.current = null;
    setMultiVendorView(true);
    setShowCoupons(true);
    setSelectedCoupons([]);

    const requests = selectedVendors.map((v) =>
      axios.get(`/coupons/vendorid/?vendor_id=${v.id}`).then((res) => ({
        vendor_name: v.vendor_name,
        coupons: res.data,
      }))
    );

    Promise.all(requests).then((results) => {
      const arr = [];
      results.forEach(({ vendor_name, coupons: coupons_list }) => {
        if (coupons_list && coupons_list.length > 0) {
          coupons_list.forEach((o) => {
            arr.push({
              key: o.id,
              coupon_id: o.coupon_id,
              vendor_name,
              creation_date: o.creation_date,
              activation_date: o.activation_date,
              expiration_date: o.expiration_date,
              duration: o.duration,
              state: o.state,
              usage_limit: o.usage_limit,
              usage_count: o.usage_count,
              comment: o.comment,
            });
          });
        }
      });
      currCouponsTable.current = arr;
      setCoupons(arr);
      setSpin(false);
    });
  }
  function handleCouponClick(coupon_id) {
    axios.get(`/coupons/coupon_activation_details/?coupon_id=${coupon_id}`)
      .then(response => {
        setTableData(response.data);
        setIsModalVisible(true);
      })
      .catch(error => {
        console.error("Error fetching the coupon details:", error);
      });
  }
  function EditVendorOpen(record) {
    editVendorRef.current = record;
    editVendorForm.setFieldsValue({
      behavior: record.behavior,
    });
    setEditVendorModal(true);
  }

  function submitEditVendor() {
    editVendorForm.validateFields().then((data) => {
      axios
        .post("/vendors/edit/", {
          id: editVendorRef.current.id,
          behavior: data.behavior,
        })
        .then((res) => {
          message.success(res.data.message);
          setEditVendorModal(false);
          editVendorForm.resetFields();
          setRefreshKey((k) => k + 1);
        })
        .catch((err) => {
          const msg = err.response?.data?.error || "Failed to update vendor";
          message.error(msg);
        });
    });
  }

  function DeleteVendor(record) {
    deleteVendorRef.current = [record];
    setForceDelete(false);
    setDeleteModal(true);
  }

  function BulkDeleteVendors() {
    deleteVendorRef.current = selectedVendors;
    setForceDelete(false);
    setDeleteModal(true);
  }

  function confirmDeleteVendor() {
    const vendorsToDelete = deleteVendorRef.current;
    if (!vendorsToDelete || vendorsToDelete.length === 0) return;
    axios
      .post("/vendors/delete/", {
        vendor_ids: vendorsToDelete.map((v) => v.id),
        force_delete: forceDelete,
      })
      .then((res) => {
        const { deleted, skipped, errors } = res.data;
        if (deleted.length > 0) {
          message.success(`${deleted.length} vendor(s) deleted`);
        }
        if (skipped.length > 0) {
          skipped.forEach((s) => message.warning(s.message));
        }
        if (errors.length > 0) {
          errors.forEach((e) => message.error(e.message));
        }
        setDeleteModal(false);
        setSelectedVendors([]);
        setRefreshKey((k) => k + 1);
      })
      .catch(() => {
        message.error("Failed to delete vendor(s)");
      });
  }

  function confirmResetUsers() {
    axios
      .post("/vendors/reset-users/", {
        vendors: selectedVendors.map((v) => v.id),
      })
      .then((res) => {
        message.success(res.data.message);
        message.info(`Users processed: ${res.data.users_processed}, Profiles deleted: ${res.data.profiles_deleted}, Profiles reset: ${res.data.profiles_reset}`);
        setResetUsersModal(false);
      })
      .catch((err) => {
        const msg = err.response?.data?.error || "Failed to reset vendor users";
        message.error(msg);
      });
  }

  function EditCoupon(record) {
    editCouponRef.current = record ? [record] : null;
    if (record) {
      editForm.setFieldsValue({
        duration: record.duration,
        usage_limit: record.usage_limit,
        expiration_date: record.expiration_date,
        state: record.state,
        comment: record.comment,
      });
    } else {
      editForm.resetFields();
    }
    setEditCouponModal(true);
  }

  function BulkEditCoupons() {
    editCouponRef.current = selectedCoupons;
    editForm.resetFields();
    setEditCouponModal(true);
  }

  function submitEditCoupon() {
    editForm.validateFields().then((data) => {
      const records = editCouponRef.current || [];
      const isBatch = records.length > 1;

      const payload = {};
      const original = !isBatch ? records[0] : null;
      if (isBatch) {
        payload.coupon_ids = records.map((r) => r.coupon_id);
      } else {
        payload.coupon_id = records[0].coupon_id;
      }
      if (data.duration != null && (!original || data.duration !== original.duration)) payload.duration = data.duration;
      if (data.usage_limit != null && (!original || data.usage_limit !== original.usage_limit)) payload.usage_limit = data.usage_limit;
      if (data.expiration_date != null && (!original || data.expiration_date !== original.expiration_date)) payload.expiration_date = data.expiration_date;
      if (data.state != null && (!original || data.state !== original.state)) payload.state = data.state;
      if (data.comment != null && (!original || data.comment !== original.comment)) payload.comment = data.comment;
      if (data.reset_activation) payload.reset_activation = true;

      axios
        .post("/coupons/edit/", payload)
        .then((res) => {
          if (isBatch) {
            const { updated, errors } = res.data;
            message.success(`${updated.length} coupon(s) updated`);
            if (errors && errors.length > 0) {
              errors.forEach((e) => message.error(`${e.coupon_id}: ${e.message}`));
            }
            if (res.data.activation_reset) {
              message.info("Activation dates reset for updated coupons");
            }
          } else {
            message.success(res.data.message);
            if (res.data.activation_reset) {
              message.info(`Activation reset for ${res.data.usages_reset} usage(s)`);
            }
          }
          setEditCouponModal(false);
          editForm.resetFields();
          setSelectedCoupons([]);
          if (currVendor.current) {
            setCouponsTable();
          } else {
            ViewSelectedVendorsCoupons();
          }
        })
        .catch((err) => {
          const msg = err.response?.data?.message || err.response?.data?.error || "Failed to update coupon(s)";
          message.error(msg);
        });
    });
  }

  function AddCoupons(record) {
    currVendor.current = record;
    couponForm.resetFields();
    showCouponsModal(true);
  }

  function AddCouponsToVendor() {
    couponForm.validateFields().then((data) => {
      axios
        .post("/coupons/create/", {
          vendor: currVendor.current.id,
          duration: data.duration,
          amount: data.amount,
          expiration_date: data.expiration_date,
          usage_limit: data.usage_limit,
          comment: data.comment,
        })
        .then((res) => {
          setRefreshKey((k) => k + 1);
        });
    });
    showCouponsModal(false);
  }

  function AddVendor() {
    showVendorModal(true);
  }
  function addVednorObject() {
    form.validateFields().then((data) => {
      if (vendors.some((v) => v.vendor_name === data.vendor_name)) {
        return message.info("vendor already exists");
      }
      axios
        .post("/vendors/create/", {
          vendor_name: data.vendor_name,
          behavior: data.behavior,
        })
        .then((res) => {
          showVendorModal(false);
          form.resetFields();
          setRefreshKey((k) => k + 1);
        });
    });
  }

  function RemoveExpired(){
    if (!currVendor.current){
      message.info("Choose vendor")
    }
    message.info("Removing expired coupons..")
    axios
    .post(`/coupons/delete-expired/?vendor_id=${currVendor.current.id}`)
    .then((res) => {
      setRefreshKey((k) => k + 1);
    });
  }


  function onVendorSearch(value) {
    setVendorSearch(value);
    vendorSearchRef.current = value;
    if (!value) {
      setVendors(sourceData.current || []);
    } else {
      const lower = value.toLowerCase();
      setVendors(
        (sourceData.current || []).filter((v) =>
          v.vendor_name.toLowerCase().includes(lower)
        )
      );
    }
  }

  function updateStep(index, status, errorMsg) {
    setFlowStatus((prev) => {
      const steps = prev.steps.map((s, i) =>
        i === index ? { ...s, status, error: errorMsg || undefined } : s
      );
      return { ...prev, steps };
    });
  }

  async function submitFullFlow() {
    let data;
    try {
      data = await fullFlowForm.validateFields();
    } catch {
      return;
    }

    const steps = [
      { label: "Creating vendor", status: "pending" },
      { label: "Creating coupons", status: "pending" },
      { label: "Adding to leaderboard", status: "pending" },
    ];
    setFlowStatus({ running: true, steps });

    updateStep(0, "processing");
    try {
      await axios.post("/vendors/create/", {
        vendor_name: data.vendor_name,
        behavior: data.behavior,
      });
    } catch (err) {
      updateStep(0, "error", err.response?.data?.error || "Failed to create vendor");
      setRefreshKey((k) => k + 1);
      return;
    }
    updateStep(0, "success");

    updateStep(1, "processing");
    let newVendorId;
    try {
      const vendorsRes = await axios.get("/vendors/all/");
      const vendorsList = vendorsRes.data.vendors || [];
      const newVendor = vendorsList.find((v) => v.vendor_name === data.vendor_name);
      if (!newVendor) throw new Error("Vendor created but not found in vendor list");
      newVendorId = newVendor.id;
      const couponRes = await axios.post("/coupons/create/", {
        vendor: newVendorId,
        duration: data.duration,
        amount: data.amount,
        expiration_date: data.expiration_date,
        usage_limit: data.usage_limit,
        comment: data.comment || "",
      });
      if (couponRes.data && couponRes.data.error) {
        throw new Error(couponRes.data.error);
      }
    } catch (err) {
      updateStep(1, "error", err.response?.data?.error || err.message || "Failed to create coupons");
      setRefreshKey((k) => k + 1);
      return;
    }
    updateStep(1, "success");

    updateStep(2, "processing");
    try {
      const lbFields = {
        display_name: data.lb_display_name || "",
        city: data.lb_city || "",
        childrean_num: data.lb_childrean_num != null ? data.lb_childrean_num : 0,
      };
      await axios.post("/dashboard/limit/leaderboard-data-update/", {
        l_name: data.leaderboard_name,
        vendor_name: data.vendor_name,
        vendor_data: lbFields,
      });
    } catch (err) {
      updateStep(2, "error", err.response?.data?.error || "Failed to add to leaderboard");
      setRefreshKey((k) => k + 1);
      return;
    }
    updateStep(2, "success");
    setRefreshKey((k) => k + 1);
  }

  function closeFullFlowModal() {
    setFullFlowModal(false);
    fullFlowForm.resetFields();
    setFlowStatus({ running: false, steps: [] });
    setLbExtraFields([]);
    setRefreshKey((k) => k + 1);
  }

  function onLeaderboardSelect(lbName) {
    setLbExtraFields([]);
    if (!lbName) return;
    setLbExtraFields([
      { key: "display_name", type: "string" },
      { key: "city", type: "string" },
      { key: "childrean_num", type: "number" },
    ]);
  }

  function setCouponsTable() {
    axios
      .get(`/coupons/vendorid/?vendor_id=${currVendor.current.id}`)
      .then((res) => {
        let coupons_list = res.data;
        currCouponsTable.current = res.data
        setSpin(false);
        let arr = [];
        if (Object.keys(coupons_list).length > 0) {
          coupons_list.map((o) => {
            arr.push({
              key: o.id,
              coupon_id: o.coupon_id,
              creation_date: o.creation_date,
              activation_date: o.activation_date,
              expiration_date: o.expiration_date,
              duration: o.duration,
              state: o.state,
              usage_limit: o.usage_limit,
              usage_count: o.usage_count,
              comment: o.comment,
            });
          });
          setCoupons(() => arr);
        }
      });
  }

  return (
    <div>
      <Row>
        <Col>
          <Button
            type="primary"
            onClick={AddVendor}
            style={{ marginBottom: 30 }}
          >
            Add vendor
          </Button>
        </Col>
        <Col>
          <Button
            type="primary"
            onClick={() => setFullFlowModal(true)}
            style={{ marginLeft: 30, marginBottom: 30 }}
          >
            Full Flow
          </Button>
        </Col>
        <Col>
          <Button
            type="primary"
            onClick={RemoveExpired}
            style={{ marginLeft: 30,marginBottom: 30 }}
          >
            Remove expired
          </Button>
        </Col>
        {selectedVendors.length > 0 && (
          <Col>
            <Button
              danger
              onClick={BulkDeleteVendors}
              style={{ marginLeft: 30, marginBottom: 30 }}
            >
              Delete Selected ({selectedVendors.length})
            </Button>
          </Col>
        )}
        {selectedVendors.length > 0 && (
          <Col>
            <Button
              type="primary"
              onClick={ViewSelectedVendorsCoupons}
              style={{ marginLeft: 30, marginBottom: 30 }}
            >
              View Coupons ({selectedVendors.length} vendors)
            </Button>
          </Col>
        )}
        {selectedVendors.length > 0 && (
          <Col>
            <Button
              danger
              onClick={() => setResetUsersModal(true)}
              style={{ marginLeft: 30, marginBottom: 30 }}
            >
              Reset Users ({selectedVendors.length})
            </Button>
          </Col>
        )}
      </Row>
      <Row style={{ marginBottom: 16 }}>
        <Col>
          <Input
            placeholder="Search vendor by name"
            value={vendorSearch}
            onChange={(e) => onVendorSearch(e.target.value)}
            allowClear
            style={{ width: 300 }}
          />
        </Col>
      </Row>
      <Table
        size="middle"
        title={() => `Vednors${selectedVendors.length > 0 ? ` (${selectedVendors.length} selected)` : ""}`}
        dataSource={vendors}
        columns={columns}
        loading={spin}
        bordered
        rowSelection={{
          selectedRowKeys: selectedVendors.map((v) => v.key),
          onChange: (_, rows) => setSelectedVendors(rows),
        }}
        pagination={{ pageSizeOptions: ["10", "25", "100"], showSizeChanger: true, defaultPageSize: 10 }}
      />
      <Modal
        visible={vendorModal}
        onOk={addVednorObject}
        onCancel={() => showVendorModal(false)}
        title={"Add vednor"}
      >
        <Form form={form}>
          <Form.Item
            name="vendor_name"
            label="Name"
            rules={[
              {
                required: true,
                message: "Input something!",
              },
              {
                max: 10,
                message: "Vendor name must be 10 characters or less",
              },
            ]}
          >
            <Input placeholder="vendor name" maxLength={10} />
          </Form.Item>
          <Form.Item
            name="behavior"
            label="Behavior"
            rules={[
              {
                required: true,
                message: "Select a behavior",
              },
            ]}
          >
            <Select placeholder="Select behavior">
              {behaviors.map((b) => (
                <Select.Option key={b} value={b}>{b}</Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        visible={editVendorModal}
        onOk={submitEditVendor}
        onCancel={() => { setEditVendorModal(false); editVendorForm.resetFields(); }}
        title={`Edit Vendor "${editVendorRef.current?.vendor_name || ""}"`}
      >
        <Form form={editVendorForm}>
          <Form.Item
            name="behavior"
            label="Behavior"
            rules={[
              {
                required: true,
                message: "Select a behavior",
              },
            ]}
          >
            <Select placeholder="Select behavior">
              {behaviors.map((b) => (
                <Select.Option key={b} value={b}>{b}</Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        visible={deleteModal}
        onOk={confirmDeleteVendor}
        onCancel={() => setDeleteModal(false)}
        title="Delete Vendor"
        okText="Delete"
        okButtonProps={{ danger: true }}
      >
        <p>{deleteVendorRef.current?.length === 1
          ? `Are you sure you want to delete vendor "${deleteVendorRef.current[0].vendor_name}"?`
          : `Are you sure you want to delete ${deleteVendorRef.current?.length || 0} vendors?`
        }</p>
        <Checkbox
          checked={forceDelete}
          onChange={(e) => setForceDelete(e.target.checked)}
        >
          Force delete (removes all associated coupons and data)
        </Checkbox>
      </Modal>
      <Modal
        visible={resetUsersModal}
        onOk={confirmResetUsers}
        onCancel={() => setResetUsersModal(false)}
        title="Reset Vendor Users"
        okText="Yes, Reset"
        okButtonProps={{ danger: true }}
        cancelText="No"
      >
        <p><strong>Warning:</strong> This will reset all users associated with the selected {selectedVendors.length} vendor(s).</p>
        <p>For each user:</p>
        <ul>
          <li>All child profiles except the first one will be <strong>deleted</strong></li>
          <li>Progress, trophies, points, and session data will be <strong>reset</strong></li>
          <li>Personal information (name, avatar, etc.) will be preserved</li>
        </ul>
        <p>This action cannot be undone. Are you sure?</p>
      </Modal>
      {/* Add coupons to vendor modal */}
      <Modal
  visible={addCoupons}
  onOk={AddCouponsToVendor}
  onCancel={() => { showCouponsModal(false); couponForm.resetFields(); }}
  title={`Add coupons to ${currVendor?.current?.vendor_name}`}
>
  <Form form={couponForm} initialValues={{ usage_limit: 1, comment: "" }}>
    <Form.Item
      name="duration"
      label="duration"
      rules={[
        {
          required: true,
          message: "Input something!",
        },
      ]}
    >
      <InputNumber placeholder="days duration" />
    </Form.Item>
    <Form.Item
      name="amount"
      label="Number of coupons"
      rules={[
        {
          required: true,
          message: "Input something!",
        },
      ]}
    >
      <InputNumber placeholder="how many coupons to create?" />
    </Form.Item>
    <Form.Item
      name="usage_limit"
      label="Redeem limit"
      rules={[
          {
              required: true,
              message: "This field is required!"
          },
          {
              validator: (_, value) => 
                  value > 0 
                      ? Promise.resolve()
                      : Promise.reject("Number must be greater than 0!")
          }
      ]}
    >
      <InputNumber placeholder="how many times can be used?" min={1} />
    </Form.Item>
    <Form.Item
      name="comment"
      label="comment"
      rules={[
        {
          required: false,
          message: "Please add a comment!",
        },
      ]}
    >
      <Input placeholder="Enter your comment here" />
    </Form.Item>
    {/* Note: Added a reminder comment about the format */}
    {/* Example format 2023-10-02 00:00 */}
    <Form.Item
      name="expiration_date"
      label="expiration date"
      rules={[
        {
          required: true,
          message: "Input something!",
        },
      ]}
    >
      <Input placeholder="2023-10-02 00:00" />
    </Form.Item>
  </Form>
</Modal>
      <Modal
        visible={editCouponModal}
        onOk={submitEditCoupon}
        onCancel={() => { setEditCouponModal(false); editForm.resetFields(); }}
        title={editCouponRef.current?.length > 1
          ? `Edit ${editCouponRef.current.length} coupons`
          : `Edit coupon ${editCouponRef.current?.[0]?.coupon_id || ""}`
        }
      >
        <Form form={editForm} layout="vertical">
          <Form.Item name="duration" label="Duration (days)">
            <InputNumber placeholder="days duration" style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item name="usage_limit" label="Redeem limit">
            <InputNumber placeholder="redeem limit" min={1} style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item name="expiration_date" label="Expiration date">
            <Input placeholder="2023-10-02 00:00" />
          </Form.Item>
          <Form.Item name="state" label="State">
            <Select>
              <Select.Option value="valid">valid</Select.Option>
              <Select.Option value="expired">expired</Select.Option>
              <Select.Option value="used">used</Select.Option>
              <Select.Option value="invalid">invalid</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name="comment" label="Comment">
            <Input placeholder="Enter comment" />
          </Form.Item>
          <Form.Item name="reset_activation" valuePropName="checked">
            <Checkbox>Reset activation (restart subscription timer for all users)</Checkbox>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title="Coupon Activation Details"
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width={800}
      >
        <Table dataSource={tableData} columns={detailColumns} /> 
        {/* <-- This is where detailColumns is used */}
      </Modal>

      <Modal
        visible={fullFlowModal}
        onCancel={() => { if (!flowStatus.steps.some((s) => s.status === "processing")) closeFullFlowModal(); }}
        title="Full Flow — Create Vendor + Coupons + Leaderboard"
        width={600}
        maskClosable={false}
        footer={
          <div style={{ textAlign: "right" }}>
            {!flowStatus.running && flowStatus.steps.length === 0 && (
              <>
                <Button onClick={closeFullFlowModal} style={{ marginRight: 8 }}>Cancel</Button>
                <Button type="primary" onClick={submitFullFlow}>Create</Button>
              </>
            )}
            {flowStatus.steps.length > 0 && (
              <Button
                type="primary"
                disabled={flowStatus.steps.some((s) => s.status === "processing")}
                onClick={closeFullFlowModal}
              >
                OK
              </Button>
            )}
          </div>
        }
      >
        <Form form={fullFlowForm} layout="vertical" disabled={flowStatus.running}>
          <Divider orientation="left">Vendor</Divider>
          <Form.Item
            name="vendor_name"
            label="Vendor Name"
            rules={[{ required: true, message: "Vendor name is required" }, { max: 10, message: "Max 10 characters" }]}
          >
            <Input placeholder="vendor name" maxLength={10} />
          </Form.Item>
          <Form.Item
            name="behavior"
            label="Behavior"
            rules={[{ required: true, message: "Select a behavior" }]}
          >
            <Select placeholder="Select behavior">
              {behaviors.map((b) => (
                <Select.Option key={b} value={b}>{b}</Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Divider orientation="left">Coupons</Divider>
          <Form.Item name="duration" label="Duration (days)" rules={[{ required: true, message: "Required" }]}>
            <InputNumber placeholder="days duration" style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item name="amount" label="Number of coupons" rules={[{ required: true, message: "Required" }]}>
            <InputNumber placeholder="how many coupons?" style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            name="usage_limit"
            label="Redeem limit"
            rules={[{ required: true, message: "Required" }, { validator: (_, v) => v > 0 ? Promise.resolve() : Promise.reject("Must be > 0") }]}
          >
            <InputNumber placeholder="redeem limit" min={1} style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item name="comment" label="Comment">
            <Input placeholder="Enter comment" />
          </Form.Item>
          <Form.Item name="expiration_date" label="Expiration date" rules={[{ required: true, message: "Required" }]}>
            <Input placeholder="2023-10-02 00:00" />
          </Form.Item>

          <Divider orientation="left">Leaderboard</Divider>
          <Form.Item
            name="leaderboard_name"
            label="Leaderboard"
            rules={[{ required: true, message: "Enter or select a leaderboard" }]}
          >
            {leaderboardList.length > 0 ? (
              <Select
                placeholder="Select a leaderboard"
                showSearch
                onChange={onLeaderboardSelect}
                filterOption={(input, option) =>
                  option.children.join("").toLowerCase().includes(input.toLowerCase())
                }
              >
                {leaderboardList.map((lb) => (
                  <Select.Option key={lb.name} value={lb.name}>
                    {lb.name}{lb.is_active ? "" : " (inactive)"}
                  </Select.Option>
                ))}
              </Select>
            ) : (
              <Input
                placeholder="Enter leaderboard name"
                onBlur={(e) => {
                  const val = e.target.value.trim();
                  if (val) onLeaderboardSelect(val);
                }}
              />
            )}
          </Form.Item>
          {lbExtraFields.map((f) => (
            <Form.Item
              key={f.key}
              name={`lb_${f.key}`}
              label={f.key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
            >
              {f.type === "number" ? <InputNumber style={{ width: "100%" }} /> : <Input />}
            </Form.Item>
          ))}
        </Form>

        {flowStatus.steps.length > 0 && (
          <div style={{ marginTop: 24 }}>
            <Divider orientation="left">Progress</Divider>
            {flowStatus.steps.map((step, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", marginBottom: 12 }}>
                <span style={{ width: 24, marginRight: 12, display: "flex", justifyContent: "center" }}>
                  {step.status === "processing" && <Spin size="small" />}
                  {step.status === "success" && <CheckCircleTwoTone twoToneColor="#52c41a" />}
                  {step.status === "error" && <CloseCircleTwoTone twoToneColor="#f5222d" />}
                </span>
                <span style={{
                  color: step.status === "pending" ? "#999" : step.status === "error" ? "#f5222d" : undefined,
                  fontWeight: step.status === "processing" ? "bold" : undefined,
                }}>
                  {step.label}
                  {step.error && <span style={{ marginLeft: 8, fontSize: 12 }}>— {step.error}</span>}
                </span>
              </div>
            ))}
          </div>
        )}
      </Modal>

      {showCoupons ? (
        <div>
          {selectedCoupons.length > 1 && (
            <Button
              type="primary"
              onClick={BulkEditCoupons}
              style={{ marginBottom: 10 }}
            >
              Bulk Edit ({selectedCoupons.length} selected)
            </Button>
          )}
          <Table
            size="middle"
            title={() =>
              currVendor.current
                ? `Coupons for ${currVendor.current.vendor_name}`
                : `Coupons for ${selectedVendors.length} vendors`
            }
            dataSource={coupons}
            rowSelection={{
              selectedRowKeys: selectedCoupons.map((c) => c.key),
              onChange: (_, rows) => setSelectedCoupons(rows),
            }}
            pagination={{ pageSize: 8 }}
            columns={
              multiVendorView
                ? [{ key: "vendor_name", title: "Vendor", dataIndex: "vendor_name", width: 150 }, ...coupon_colums]
                : coupon_colums
            }
            loading={spin}
            bordered
          />
        {currVendor.current && (
          <Row>
            <Col>
              <ToExcel apiData={currCouponsTable.current} fileName={currVendor.current.vendor_name}/>
            </Col>
          </Row>
        )}
        </div>
        
      ) : (
        <div>Choose a vendor to view coupons</div>
      )}
      
    </div>
  );
}
